import React, { useContext, useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { FileText, LogIn, Mail, User } from "react-feather";
import man from "../../../assets/images/user/user.png";

import { LI, UL, Image, P } from "../../../AbstractElements";
import CustomizerContext from "../../../_helper/Customizer";
import { Account, Admin, Inbox, LogOut, Taskboard } from "../../../Constant";

const UserHeader = () => {

  const history = useNavigate();
  const [profile, setProfile] = useState(man);
  const [name, setName] = useState(localStorage.getItem("Name"));
  const authenticated = useState(JSON.parse(localStorage.getItem("authenticated")))[0];
  const [auth0_profile, setAuth0_profile] = useState(null);
  const login = useState(JSON.parse(localStorage.getItem("login")))[0];
  const [omang, setOmang] = useState(localStorage.getItem("omang"));
  const [DRTSAccessible, setDRTSAccessible] = useState(false);

      //const [value, setValue] = useState(localStorage.getItem("profileURL" || man));
      //const [name, setName] = useState(localStorage.getItem("Name"));
      //setValue(man);
      //setName(" ");
      //JSON.parse(localStorage.getItem("auth0_profile"));

useEffect(() => {

  if(!login && localStorage.getItem("login")!='true'){//alert(" -- "+localStorage.getItem("login"));
    //history(`${process.env.PUBLIC_URL}/login`); 
      setDRTSAccessible(false);     
     }
     else{//alert(" ++ "+localStorage.getItem("login"));
      setDRTSAccessible(true);
     }

  }, []);

  const Logout = () => {
    localStorage.removeItem("omang");
    localStorage.removeItem("token");
    localStorage.removeItem("auth0_profile");
    localStorage.removeItem("firstname");
    localStorage.removeItem("surname");
    localStorage.removeItem("phone_number");
    localStorage.removeItem("user_id");
    localStorage.setItem("authenticated", false);
    localStorage.setItem("login", false);

    localStorage.removeItem("username");
    //localStorage.removeItem("role");
    localStorage.removeItem('login_datetime');  
    localStorage.removeItem('session_state');
    localStorage.removeItem('token_expires_in');
    localStorage.removeItem("refresh_token");

    history(`${process.env.PUBLIC_URL}/login`);
  };

  const UserMenuRedirect = (redirect) => {
    history(redirect);
  };

  const [isMenuHoveringA, setIsMenuHoveringA] = useState(false);
  const [isMenuHoveringB, setIsMenuHoveringB] = useState(false);

  return (
    
    <li className="profile-nav onhover-dropdown" style={{paddingTop:0,margin:0,paddingBottom:0}}>
      {!DRTSAccessible ? (<span>
        <div className="media profile-media " style={{paddingTop:0,margin:0,paddingBottom:0}}>

	    <img className='img b-r-10 m-0' src={man} alt='' style={{paddingTop:3,margin:0,paddingBottom:0,width:35}} />
        
      <div className="media-body" style={{paddingLeft:10,paddingTop:6,paddingBottom:0,margin:0}}>
         
      <ol className='breadcrumb' style={{width:"100%", textAlign:"center", margin:0,paddingBottom:0, paddingTop:0,paddingLeft:5, paddingRight:5}} > 

         <li className='drts-menu-item' style={{ paddingRight:8, paddingLeft:8, paddingBottom:0, color:isMenuHoveringA ? '#6ec6ec' :"#000000" }} 
          onMouseEnter={() => setIsMenuHoveringA(true)}
          onMouseLeave={() => setIsMenuHoveringA(false)}>
             <Link to={`${process.env.PUBLIC_URL}/eservices/login`}
                style={{color:isMenuHoveringA ? '#6ec6ec' :"#000000" }}>{ " Login"}</Link>
         </li>
         <li className='drts-menu-item' style={{ paddingRight:8, paddingLeft:8, paddingBottom:0, color:isMenuHoveringB ? '#6ec6ec' :"#000000" }} 
          onMouseEnter={() => setIsMenuHoveringB(true)}
          onMouseLeave={() => setIsMenuHoveringB(false)}>
             <Link to={`${process.env.PUBLIC_URL}/eservices/register`}
                style={{color:isMenuHoveringB ? '#6ec6ec' :"#000000" }}>{ " Register"}</Link>
         </li>

       </ol>

      </div>
        
      </div>
        </span>) :
      (<span><div className="media profile-media " style={{paddingTop:0,margin:0,paddingBottom:0}}>

	    <img className='img b-r-10 m-0' src={man} alt='' style={{paddingTop:3,margin:0,paddingBottom:0,width:35}} />
        
      <div className="media-body" style={{paddingLeft:10,paddingTop:6,paddingBottom:0,margin:0}}>
        <span style={{margin:0,paddingBottom:0,paddingTop:0}}>
          {localStorage.getItem("firstname")} {" "}{localStorage.getItem("surname")}</span>
          {/*<span>{authenticated ? auth0_profile.name : name}</span>localStorage.getItem("Name")*/}
          <p attrPara={{ className: "font-roboto" }} style={{paddingTop:0,margin:0,paddingBottom:0,width:5, height:5}}>
             <i className="middle fa fa-angle-down"></i>
          </p>
        </div>
        
      </div>
      <UL attrUL={{ className: "simple-list profile-dropdown onhover-show-div" }} style={{margin:0,paddingBottom:0}}>
        <LI
          attrLI={{
            onClick: () => UserMenuRedirect(`${process.env.PUBLIC_URL}/eservices/MyTransactions`),
          }}>
          <User />
          <span>{"My Transactions"} </span>
        </LI>
       
        <LI
          attrLI={{
            onClick: () => UserMenuRedirect(`${process.env.PUBLIC_URL}/eservices/MyDrafts`),
          }}>
          <FileText />
          <span>{"Drafts"}</span>
        </LI>
        <LI attrLI={{ onClick: Logout }}>
          <LogIn />
          <span>{LogOut}</span>
        </LI>
      </UL></span>)}
    </li>
  );
};

export default UserHeader;
